import "./style.scss";
import ActionMenuItem from "./ActionMenuItem";
import ActionTab from "./ActionTab";
import { ActionBuilderType, getIconByType } from "@builder/utils/actionBuilderHelpers";
import { Fragment, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import {
    ActionEditorItem,
    removeBuilderAction,
    setActiveStepperIndex,
    setCurrent,
    updateActionEditor
} from "@builder/store/slices/actionBuilderSlice";
import { v4 } from "uuid";
import { useTranslation } from "react-i18next";

const ActionBuilder = () => {
    const { actionsEditor, activeStepperIndex } = useAppSelector(state => state.actionBuilder);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const setTab = (tab: ActionBuilderType, id: string) => {
        dispatch(setCurrent({ tab, id }));
    };

    const handleAddNew = useCallback((index?: number) => {
        const newStep: ActionEditorItem = {
            id: v4(),
            type: ActionBuilderType.NEW,
            title: "New step",
            action: null
        };
        dispatch(updateActionEditor({ index: index, item: newStep }));
        setTab(newStep.type as ActionBuilderType, newStep.id || "");
    }, []);

    return (
        <div className="action-menu">
            <div className="action-stepper">
                {actionsEditor.map((item, index) => (
                    <Fragment key={item.id}>
                        {index !== 0 && (
                            <div className="stepper">
                                <div className="divider-stepper" />
                                <img className="stepper-add" src={"./stepper-add-icon.svg"} onClick={() => handleAddNew(index)} />
                                <div className="divider-stepper" />
                            </div>
                        )}
                        <ActionMenuItem
                            icon={getIconByType(item.type)}
                            title={
                                item.type === ActionBuilderType.START
                                    ? item?.isAuto
                                        ? t("popup.actionBuilder.When conditions are met")
                                        : t("popup.actionBuilder.On Click")
                                    : item.title
                            }
                            onClick={() => {
                                setTab(item.type as ActionBuilderType, item.id || "");
                                dispatch(setActiveStepperIndex(index));
                            }}
                            active={activeStepperIndex === index}
                            onDelete={
                                item.id && item.type !== ActionBuilderType.START
                                    ? () => {
                                          dispatch(removeBuilderAction(item.id!));
                                      }
                                    : undefined
                            }
                            noTranslate={item.noTranslate}
                        />
                    </Fragment>
                ))}
                <div className="stepper-dashed">
                    <div className="divider-stepper dashed" />
                </div>
                <div className="stepper-add-button" onClick={() => handleAddNew()}>
                    <img className="stepper-add-icon" src={"./stepper-add-icon-blue.svg"} />
                    <p className="stepper-add-button-text">{t("popup.actionBuilder.Add step")}</p>
                </div>
            </div>

            <div className="action-menu-items">
                <ActionTab />
            </div>
        </div>
    );
};

export default ActionBuilder;
